export default class Concept {
  public openalex_id = "";
  public name = "";
  public normalized_name = "";
  public level: number;
  public wikidata_id = "";
  public created_at?: string;
  public updated_at?: string;
}
